var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.559,
    height: 25.79,
    viewBox: "0 0 19.559 25.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inactive_Reports",
    transform: "translate(-18.221 -567.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5506",
    "data-name": "Group 5506",
    transform: "translate(0.221 228.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(0 44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699",
    transform: "translate(0.289 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3698",
    "data-name": "Group 3698",
    transform: "translate(17.576 293.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M26.217,6.309H25.168v.677a2.032,2.032,0,0,1-2.027,2.031H16.112a2.033,2.033,0,0,1-2.031-2.031V6.309H13.036A3.188,3.188,0,0,0,9.847,9.5V27.285a3.192,3.192,0,0,0,3.189,3.193H26.217a3.192,3.192,0,0,0,3.189-3.193V9.5A3.188,3.188,0,0,0,26.217,6.309ZM14.11,11.04a.8.8,0,0,1,.8-.8h9.432a.8.8,0,0,1,.8.8v1.271a.8.8,0,0,1-.8.8H14.908a.8.8,0,0,1-.8-.8Zm3.034,15.488a1.2,1.2,0,0,1-1.2,1.2H13.684a1.2,1.2,0,0,1-1.2-1.2V24.175a1.2,1.2,0,0,1,1.2-1.2H15.94a1.2,1.2,0,0,1,1.2,1.2Zm.109-6.933a1.229,1.229,0,0,1-1.233,1.229H13.709a1.228,1.228,0,0,1-1.229-1.229V17.188a1.228,1.228,0,0,1,1.229-1.229H16.02a1.229,1.229,0,0,1,1.233,1.229Zm9.518,7.355H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-2.248H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-4.769H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-2.248H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Z",
    transform: "translate(-9.712 -4.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M21.736,5.617h7.028a1.193,1.193,0,0,0,1.193-1.193V3.193A1.193,1.193,0,0,0,28.764,2H21.736a1.193,1.193,0,0,0-1.193,1.193v1.23A1.193,1.193,0,0,0,21.736,5.617Zm-.7,9.58-.826.562-.137-.233a.418.418,0,0,0-.721.424l.363.617a.418.418,0,0,0,.6.134l1.195-.812a.418.418,0,0,0-.47-.691Zm0,6.991-.826.562-.137-.233a.418.418,0,0,0-.721.424l.363.617a.418.418,0,0,0,.6.134l1.195-.812a.418.418,0,0,0-.47-.691Z",
    transform: "translate(-15.472 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 17,
    height: 19,
    transform: "translate(18.71 298)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5504",
    "data-name": "Group 5504",
    transform: "translate(6.335 565.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5505",
    "data-name": "Group 5505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M27.794,21.916h2.048a.2.2,0,0,0,.2-.2.214.214,0,0,0-.02-.086,2.646,2.646,0,0,0-2.2-2.15.194.194,0,0,0-.157.047.191.191,0,0,0-.067.149v2.04A.2.2,0,0,0,27.794,21.916Z",
    transform: "translate(-8.111 -10.725)",
    fill: "#4983e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M23.264,14.02a3.467,3.467,0,0,0,.446.031,2.85,2.85,0,0,0,2.906-2.24.2.2,0,0,0-.048-.161.235.235,0,0,0-.165-.067H23.5V8.956a.187.187,0,0,0-.078-.149.224.224,0,0,0-.173-.047,2.714,2.714,0,0,0-2.443,3.048A2.808,2.808,0,0,0,23.264,14.02Zm8.624,5.931H30.312a.205.205,0,0,0-.217.2.208.208,0,0,0,.217.2h1.053l-2.941,2.664a.948.948,0,0,0-.836,0L25.595,21.2a.713.713,0,0,0-.13-.922.933.933,0,0,0-1.191,0,.713.713,0,0,0-.13.922l-2.109,1.91a.84.84,0,0,0-1.26.655.8.8,0,0,0,.84.765.765.765,0,0,0,.728-1.145l2.109-1.91a.878.878,0,0,0,.836,0l1.992,1.808a.708.708,0,0,0,.13.918.9.9,0,0,0,1.191,0,.7.7,0,0,0,.13-.918l2.941-2.664v.953a.205.205,0,0,0,.217.2.208.208,0,0,0,.217-.2V20.147A.209.209,0,0,0,31.888,19.951ZM27.563,12.07h4.323a.2.2,0,1,0,0-.392H27.563a.2.2,0,1,0,0,.392Zm-6.575,3.352h10.9a.2.2,0,1,0,0-.392h-10.9a.2.2,0,1,0,0,.392Zm6.575-1.676h4.323a.2.2,0,1,0,0-.392H27.563a.2.2,0,1,0,0,.392ZM20.988,17.1h10.9a.2.2,0,1,0,0-.392h-10.9a.2.2,0,1,0,0,.392Zm6.575-6.7h4.323a.2.2,0,1,0,0-.392H27.563a.2.2,0,1,0,0,.392Zm-6.575,8.379h10.9a.2.2,0,1,0,0-.392h-10.9a.2.2,0,1,0,0,.392Z",
    transform: "translate(-4.607)",
    fill: "#4983e6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveReports);
export default __webpack_public_path__ + "static/media/Inactive_Reports.068f66d3769259dc08218d30fac86672.svg";
export { ForwardRef as ReactComponent };